<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">Create snapshot</span>
    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" alt="Close button" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="snapshotForm">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group required">
            <div class="services-form">
              <input
                type="text"
                formControlName="versionName"
                [maxlength]="maxVersionNameLength"
                placeholder="Version name *"
              />
              <label>Version name</label>
            </div>
            <div
              class="input-error"
              *ngIf="f['versionName']?.touched && f['versionName']?.errors?.['required']"
            >
              Version name is required.
            </div>
            <div
              class="input-error"
              *ngIf="f['versionName']?.touched && f['versionName']?.errors?.['maxlength']"
            >
              Version name cannot exceed {{ maxVersionNameLength }} characters.
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group">
            <label *ngIf="snapshotForm.get('schemaVersion')?.value" class="sub-header-drpdown pb-2">
              Schema version
            </label>
            <ng-select
              [clearable]="false"
              [clearOnBackspace]="false"
              [items]="schemaVersions"
              [searchable]="false"
              bindLabel="name"
              formControlName="schemaVersion"
              placeholder="Schema version"
            >
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="form-group checkbox-text auto-promote-check">
            <input
              type="checkbox"
              class="chkOverview"
              id="chkAutoPromote"
              formControlName="autoPromote"
            />
            <label for="chkAutoPromote" class="ps-2">
              Auto promote (immediately set this version as active after creation)
            </label>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()" [disabled]="submitting">
      Cancel
    </button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      (click)="onCreate()"
      [disabled]="submitting"
    >
      <span *ngIf="submitting">
        <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
        Creating… (1–2 minutes)
      </span>
      <span *ngIf="!submitting">Create</span>
    </button>
  </div>
</div>
